import { createSelector } from '@reduxjs/toolkit';
export const combinedContactsSelector = createSelector([
    (state) => state.contacts.phonebook,
    (state) => state.contacts.phones,
    (state) => state.contacts.virtuals,
], (phonebook, phones, virtuals) => [...phonebook, ...phones, ...virtuals]);
export const combinedEndpointsSelector = createSelector([
    (state) => state.contacts.phones,
    (state) => state.contacts.virtuals,
], (phones, virtuals) => [...phones, ...virtuals]);
export const contactNamesByNumberSelector = createSelector([
    (state) => state.contacts.phonebook,
    (state) => state.contacts.phones,
    (state) => state.contacts.virtuals,
], (phonebook, phones, virtuals) => {
    const map = {};
    phonebook.forEach((x) => (map[x.phoneNumber] = x.name));
    phones.forEach((x) => (map[x.shortNumber] = x.name));
    virtuals.forEach((x) => (map[x.shortNumber] = x.name));
    return map;
});
export const visibleContactsSelector = createSelector([
    combinedContactsSelector,
    (state) => state.contacts.visibilityFilter,
    (state) => state.contacts.searchString,
], (allContacts, filter, searchString) => {
    let visibleContacts;
    // Get visible contacts based on visiblity filter
    switch (filter) {
        case 'SHOW_ALL': {
            visibleContacts = allContacts;
            break;
        }
        case 'SHOW_PHONEBOOK': {
            visibleContacts = allContacts.filter((c) => c.type === 'phonebookentry');
            break;
        }
        case 'SHOW_ENDPOINTS': {
            visibleContacts = allContacts.filter((c) => c.type !== 'phonebookentry');
            break;
        }
        default: {
            visibleContacts = allContacts;
            break;
        }
    }
    if (!searchString) {
        return visibleContacts.sort((a, b) => {
            if (a.name < b.name)
                return -1;
            if (a.name > b.name)
                return 1;
            return 0;
        });
    }
    return visibleContacts;
});
export const availableExtensionsSelector = createSelector([(state) => state.contacts.phones], (phones) => phones.filter((x) => !x.readOnly && x.webRTCEnabled !== false));
